import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./creatifa.css";
import LoginBrief from "./pages/customer/LoginBrief";
import RegistBrief from "./pages/customer/RegistBrief";
import HomeBrief from "./pages/customer/HomeBrief";
import CreateBrief from "./pages/customer/CreateBrief";
import ViewBrief from "./pages/customer/ViewBrief";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminViewBrief from "./pages/admin/AdminViewBrief";
import AdminEditBrief from "./pages/admin/AdminEditBrief";
import LoginAnonim from "./pages/customer/LoginAnonim";
import EditUser from "./pages/customer/EditUser";

function App() {
  return (
    <div>
      <BrowserRouter>
        <div>
          <Switch>
            <Route exact path="/" component={HomeBrief} />
            <Route path="/create/:btype" component={CreateBrief} />
            <Route exact path="/login" component={LoginBrief} />
            <Route exact path="/anonymous/login" component={LoginAnonim} />
            <Route exact path="/register" component={RegistBrief} />
            <Route exact path="/info-pengguna" component={EditUser} />
            <Route path="/view/:btype/:id" component={ViewBrief} />
            <Route exact path="/admincre/login" component={AdminLogin} />
            <Route exact path="/admincre" component={AdminDashboard} />
            <Route
              path="/admincre/view/:customerid/:btype/:briefid"
              component={AdminViewBrief}
            />
            <Route path="/admincre/edit/:btype" component={AdminEditBrief} />
          </Switch>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
